import { FEATURE_FLAG_REGIME_DRAFT_LOCKING } from "./server/feature-flag-regime-draft-locking.mjs"
import { isEnabled } from "lib/@components/feature"
import { usePlanRoot } from "lib/use-plan-root"
import { RegimeDraftLockChecker } from "./regime-draft-lock-checker"

export function RegimeDraftLock({ children }) {
    const regime = usePlanRoot()
    if (!isEnabled(FEATURE_FLAG_REGIME_DRAFT_LOCKING) || !regime) return children

    return <RegimeDraftLockChecker regime={regime}>{children}</RegimeDraftLockChecker>
}
